export const CategoriesTableColumns = (isArabic) => [
    { id: 'name', labelEn: 'Name', labelAr: 'الاسم', align: 'start' },
    { id: 'slug', labelEn: 'Slug', labelAr: 'الرابط (Slug)', align: 'start' },
    { id: 'is_active', labelEn: 'Status', labelAr: 'الحالة', align: 'center' },
    { id: 'created_at', labelEn: 'Created At', labelAr: 'تاريخ الإضافة', align: 'start' }
];
